import secureAxios from '../secure_axios';

const baseUrl = 'status/'

async function servGetAllStatusEmAberto() {
    const response = await secureAxios.get(baseUrl + 'abertos')
    return response.data
}

async function servGetAllStatusTransitorios() {
    const response = await secureAxios.get(baseUrl + 'transitorios')
    return response.data
}

export {
    servGetAllStatusEmAberto,
    servGetAllStatusTransitorios
}